import { useGetAllExports } from "@/queries/exports/get-all.legacy";
import { ExportsComponent } from "./component";

import { ErrorMessage } from "@/components/ui/error";
import { LoadingSpinner } from "@/components/ui/spinner";

export const ExportContainer = () => {
  const { exports, loading, error, refetch } = useGetAllExports({
    fetchPolicy: "network-only",
  });

  if (loading) {
    return (
      <div className="flex-1 flex justify-center items-center h-full">
        <LoadingSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex-1 flex justify-center items-center h-full">
        <ErrorMessage retry={refetch} />
      </div>
    );
  }

  return <ExportsComponent data={exports} />;
};
